import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const PreOxygenation = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Pre-Oxygenation Performed</InputLabel>
      <Select
        value={moduleValues?.['Pre-Oxygenation Performed'] ?? ''}
        label="Pre-Oxygenation Performed"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Pre-Oxygenation Performed']: e.target.value,
          }))
        }
      >
        {['Yes', 'No', 'Unable'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default PreOxygenation
